import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dayjs } from "dayjs";

interface AuditInfo {
  userNameSearch: string;
  auditLogParticipantName: string;
  participantIdSearch: string;
  eventSearch: string;
  transactionDateSearch: string;
  rowsPerPage: number;
  page: number;
  month: string;
  options: string;
  fromDate: Dayjs | null;
  toDate: Dayjs | null;
}

const initialState: AuditInfo = {
  userNameSearch: "",
  auditLogParticipantName: "All",
  participantIdSearch: "-1",
  eventSearch: "",
  transactionDateSearch: "",
  rowsPerPage: 5,
  page: 0,
  month: "",
  options: "",
  fromDate: null, 
  toDate: null,
};

const createAuditLogSlice = createSlice({
  name: "auditLog",
  initialState,
  reducers: {
    setCreateAuditLog: (state, action: PayloadAction<Partial<AuditInfo>>) => {
      return { ...state, ...action.payload };
    },
    removeAuditLog: () => initialState,
  },
});

export const { setCreateAuditLog, removeAuditLog } =
  createAuditLogSlice.actions;
export default createAuditLogSlice.reducer;
